<template>
  <section
    class="message__questionnaire"
    :class="{ 'message__questionnaire--start': start }"
  >
    <div class="questionnaire__label">
      <WIcon :icon="questionnaireControls.icon" class="label__icon" />
      {{ questionnaireControls.label }}
    </div>
    <div v-if="start" class="questionnaire__content">{{ content }}</div>
  </section>
</template>

<script>
import { WIcon } from '@alice-health/wonderland-vue'
export default {
  components: { WIcon },
  props: {
    start: {
      type: Boolean
    },
    content: {
      type: String,
      default: ''
    }
  },
  computed: {
    questionnaireControls() {
      if (this.start) {
        return {
          label: 'Início do Questionário',
          icon: 'icProtocol'
        }
      }
      return { label: 'Fim do Questionário', icon: 'icCheckOutlined' }
    }
  }
}
</script>

<style lang="scss">
.message__questionnaire {
  text-align: center;
  padding-bottom: var(--gl-spacing-06);
  padding-top: var(--gl-spacing-04);
  border-bottom: var(--gl-border-width-xs) dashed var(--gl-color-shades-blue-40);

  &--start {
    padding-top: var(--gl-spacing-06);
    padding-bottom: var(--gl-spacing-04);
    border-top: var(--gl-border-width-xs) dashed var(--gl-color-shades-blue-40);
    border-bottom: 0;
    margin-top: var(--gl-spacing-04);
  }

  .questionnaire__label {
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--gl-color-shades-blue-40);
    font-size: var(--gl-font-size-xxxs);
    font-weight: var(--gl-font-weight-regular);

    .label__icon {
      fill: var(--gl-color-shades-blue-40);
      margin-right: var(--gl-spacing-03);
    }
  }
  .questionnaire__content {
    color: var(--sys-color-content-primary);
    font-size: var(--gl-font-size-xs);
    font-weight: var(--gl-font-weight-semibold);
    line-height: var(--gl-line-height-xxs);
  }
}
</style>
